import http from '@/utils/ajax'
import {
  SPECFUNCACCT_INIT_LOADING,
  SPECFUNCACCT_INIT_SUCCESS,
  SPECFUNCACCT_INIT_FAIL,
  COMVOUCHER_INIT_LOADING,
  COMVOUCHER_INIT_SUCCESS,
  COMVOUCHER_INIT_FAIL,
  VOID_ACCOUNT_TRANSACTION_INIT_LOADING,
  VOID_ACCOUNT_TRANSACTION_INIT_SUCCESS,
  VOID_ACCOUNT_TRANSACTION_INIT_FAIL,
  POST_EXCHANGE_DIFFERENCES_LOADING,
  POST_EXCHANGE_DIFFERENCES_SUCCESS,
  POST_EXCHANGE_DIFFERENCES_FAIL,
  WRITE_OFF_SMALL_BALANCE_LOADING,
  WRITE_OFF_SMALL_BALANCE_SUCCESS,
  WRITE_OFF_SMALL_BALANCE_FAIL,
  DIRECTOR_RELATIONSHIP_LOADING,
  DIRECTOR_RELATIONSHIP_SUCCESS,
  DIRECTOR_RELATIONSHIP_FAIL,
  EXCL_GST_PATCHING_LOADING,
  EXCL_GST_PATCHING_SUCCESS,
  EXCL_GST_PATCHING_FAIL,
  GST_REBILLING_LOADING,
  GST_REBILLING_SUCCESS,
  GST_REBILLING_FAIL,
  DOWNLOAD_GL_TRAN_LOADING,
  DOWNLOAD_GL_TRAN_SUCCESS,
  DOWNLOAD_GL_TRAN_FAIL,
  IFRS_DATA_EXTRACTION_LOADING,
  IFRS_DATA_EXTRACTION_SUCCESS,
  IFRS_DATA_EXTRACTION_FAIL
} from '@/store/types'
import { extractMenu, extractMessages } from '@/utils/extract'

const state = {
  init: 0,
  initErr: [],
  menu: {},
  comVoucher: {
    init: 0,
    initErr: [],
    menu: {}
  },
  voidAccountTransaction: {
    init: 0,
    initErr: [],
    menu: {}
  },
  postExchangeDifferences: {
    init: 0,
    initErr: [],
    menu: {}
  },
  writeOffSmalBal: {
    init: 0,
    initErr: [],
    menu: {}
  },
  directorRelationship: {
    init: 0,
    initErr: [],
    menu: {}
  },
  exclGsttran: {
    init: 0,
    initErr: [],
    menu: {}
  },
  gstRebilling: {
    init: 0,
    initErr: [],
    menu: {}
  },
  downloadGLTran: {
    init: 0,
    initErr: [],
    menu: {}
  },
  ifrsDataExtraction: {
    init: 0,
    initErr: [],
    menu: {}
  }
}

const mutations = {
  [SPECFUNCACCT_INIT_LOADING](state) {
    state.init = 0
    state.initErr = []
    state.menu = {}
  },
  [SPECFUNCACCT_INIT_SUCCESS](state, data) {
    state.init = 1
    state.initErr = []
    state.menu = data.menu
  },
  [SPECFUNCACCT_INIT_FAIL](state, error) {
    state.init = 2
    state.initErr = error
    state.menu = {}
  },
  [COMVOUCHER_INIT_LOADING](state) {
    state.comVoucher.init = 0
    state.comVoucher.initErr = []
    state.comVoucher.menu = {}
  },
  [COMVOUCHER_INIT_SUCCESS](state, data) {
    state.comVoucher.init = 1
    state.comVoucher.initErr = []
    state.comVoucher.menu = data.menu
  },
  [COMVOUCHER_INIT_FAIL](state, error) {
    state.comVoucher.init = 2
    state.comVoucher.initErr = error
    state.comVoucher.menu = {}
  },
  [VOID_ACCOUNT_TRANSACTION_INIT_LOADING](state) {
    state.voidAccountTransaction.init = 0
    state.voidAccountTransaction.initErr = []
    state.voidAccountTransaction.menu = {}
  },
  [VOID_ACCOUNT_TRANSACTION_INIT_SUCCESS](state, data) {
    state.voidAccountTransaction.init = 1
    state.voidAccountTransaction.initErr = []
    state.voidAccountTransaction.menu = data.menu
  },
  [VOID_ACCOUNT_TRANSACTION_INIT_FAIL](state, error) {
    state.voidAccountTransaction.init = 2
    state.voidAccountTransaction.initErr = error
    state.voidAccountTransaction.menu = {}
  },
  [POST_EXCHANGE_DIFFERENCES_LOADING](state) {
    state.postExchangeDifferences.init = 0
    state.postExchangeDifferences.initErr = []
    state.postExchangeDifferences.menu = {}
  },
  [POST_EXCHANGE_DIFFERENCES_SUCCESS](state, data) {
    state.postExchangeDifferences.init = 1
    state.postExchangeDifferences.initErr = []
    state.postExchangeDifferences.menu = data.menu
  },
  [POST_EXCHANGE_DIFFERENCES_FAIL](state, error) {
    state.postExchangeDifferences.init = 2
    state.postExchangeDifferences.initErr = error
    state.postExchangeDifferences.menu = {}
  },
  [WRITE_OFF_SMALL_BALANCE_LOADING](state) {
    state.writeOffSmalBal.init = 0
    state.writeOffSmalBal.initErr = []
    state.writeOffSmalBal.menu = {}
  },
  [WRITE_OFF_SMALL_BALANCE_SUCCESS](state, data) {
    state.writeOffSmalBal.init = 1
    state.writeOffSmalBal.initErr = []
    state.writeOffSmalBal.menu = data.menu
  },
  [WRITE_OFF_SMALL_BALANCE_FAIL](state, error) {
    state.writeOffSmalBal.init = 2
    state.writeOffSmalBal.initErr = error
    state.writeOffSmalBal.menu = {}
  },
  [DIRECTOR_RELATIONSHIP_LOADING](state) {
    state.directorRelationship.init = 0
    state.directorRelationship.initErr = []
    state.directorRelationship.menu = {}
  },
  [DIRECTOR_RELATIONSHIP_SUCCESS](state, data) {
    state.directorRelationship.init = 1
    state.directorRelationship.initErr = []
    state.directorRelationship.menu = data.menu
  },
  [DIRECTOR_RELATIONSHIP_FAIL](state, error) {
    state.directorRelationship.init = 2
    state.directorRelationship.initErr = error
    state.directorRelationship.menu = {}
  },
  [EXCL_GST_PATCHING_LOADING](state) {
    state.exclGsttran.init = 0
    state.exclGsttran.initErr = []
    state.exclGsttran.menu = {}
  },
  [EXCL_GST_PATCHING_SUCCESS](state, data) {
    state.exclGsttran.init = 0
    state.exclGsttran.initErr = []
    state.exclGsttran.menu = data.menu
  },
  [EXCL_GST_PATCHING_FAIL](state, error) {
    state.exclGsttran.init = 2
    state.exclGsttran.initErr = error
    state.exclGsttran.menu = {}
  },
  [GST_REBILLING_LOADING](state) {
    state.gstRebilling.init = 0
    state.gstRebilling.initErr = []
    state.gstRebilling.menu = {}
  },
  [GST_REBILLING_SUCCESS](state, data) {
    state.gstRebilling.init = 0
    state.gstRebilling.initErr = []
    state.gstRebilling.menu = data.menu
  },
  [GST_REBILLING_FAIL](state, error) {
    state.gstRebilling.init = 2
    state.gstRebilling.initErr = error
    state.gstRebilling.menu = {}
  },
  [DOWNLOAD_GL_TRAN_LOADING](state) {
    state.downloadGLTran.init = 0
    state.downloadGLTran.initErr = []
    state.downloadGLTran.menu = {}
  },
  [DOWNLOAD_GL_TRAN_SUCCESS](state, data) {
    state.downloadGLTran.init = 0
    state.downloadGLTran.initErr = []
    state.downloadGLTran.menu = data.menu
  },
  [DOWNLOAD_GL_TRAN_FAIL](state, error) {
    state.downloadGLTran.init = 2
    state.downloadGLTran.initErr = error
    state.downloadGLTran.menu = {}
  },
  [IFRS_DATA_EXTRACTION_LOADING](state) {
    state.ifrsDataExtraction.init = 0
    state.ifrsDataExtraction.initErr = []
    state.ifrsDataExtraction.menu = {}
  },
  [IFRS_DATA_EXTRACTION_SUCCESS](state, data) {
    state.ifrsDataExtraction.init = 0
    state.ifrsDataExtraction.initErr = []
    state.ifrsDataExtraction.menu = data.menu
  },
  [IFRS_DATA_EXTRACTION_FAIL](state, error) {
    state.ifrsDataExtraction.init = 2
    state.ifrsDataExtraction.initErr = error
    state.ifrsDataExtraction.menu = {}
  }
}

const getters = {}

const actions = {
  async specFuncAcctInit({ commit, rootState }) {
    commit(SPECFUNCACCT_INIT_LOADING)
    const apiUrl = rootState.app.menu.specFuncAcct
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      let commitResult = {
        menu: menu
      }
      commit(SPECFUNCACCT_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(SPECFUNCACCT_INIT_FAIL, extractMessages(error))
    }
  },
  async comVoucherInit({ commit, state }) {
    commit(COMVOUCHER_INIT_LOADING)
    const apiUrl = state.menu.comVoucher
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      let commitResult = {
        menu: menu
      }
      commit(COMVOUCHER_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(COMVOUCHER_INIT_FAIL, extractMessages(error))
    }
  },
  async voidAccountTransactionInit({ commit, state }) {
    commit(VOID_ACCOUNT_TRANSACTION_INIT_LOADING)
    const apiUrl = state.menu.voidAccountTransaction
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      let commitResult = {
        menu: menu
      }
      commit(VOID_ACCOUNT_TRANSACTION_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(VOID_ACCOUNT_TRANSACTION_INIT_FAIL, extractMessages(error))
    }
  },
  async voidPostExchangeDifferencesInit({ commit, state }) {
    commit(POST_EXCHANGE_DIFFERENCES_LOADING)
    const apiUrl = state.menu.postExchangeDifferences
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      let commitResult = {
        menu: menu
      }
      commit(POST_EXCHANGE_DIFFERENCES_SUCCESS, commitResult)
    } catch (error) {
      commit(POST_EXCHANGE_DIFFERENCES_FAIL, extractMessages(error))
    }
  },
  async writeOffSmallBalInit({ commit, state }) {
    commit(WRITE_OFF_SMALL_BALANCE_LOADING)
    const apiUrl = state.menu.writeOffSmalBal
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      let commitResult = {
        menu: menu
      }
      commit(WRITE_OFF_SMALL_BALANCE_SUCCESS, commitResult)
    } catch (error) {
      commit(WRITE_OFF_SMALL_BALANCE_FAIL, extractMessages(error))
    }
  },
  async directorRelationshipInit({ commit, state }) {
    commit(DIRECTOR_RELATIONSHIP_LOADING)
    const apiUrl = state.menu.directorRelationship
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      let commitResult = {
        menu: menu
      }
      commit(DIRECTOR_RELATIONSHIP_SUCCESS, commitResult)
    } catch (error) {
      commit(DIRECTOR_RELATIONSHIP_FAIL, extractMessages(error))
    }
  },
  async exclGsttranInit({ commit, state }) {
    commit(EXCL_GST_PATCHING_LOADING)
    const apiUrl = state.menu.exclGstTran
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      let commitResult = {
        menu: menu
      }
      commit(EXCL_GST_PATCHING_SUCCESS, commitResult)
    } catch (error) {
      commit(EXCL_GST_PATCHING_FAIL, extractMessages(error))
    }
  },
  async gstRebillingInit({ commit, state }) {
    commit(GST_REBILLING_LOADING)
    const apiUrl = state.menu.gstRebilling
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      let commitResult = {
        menu: menu
      }
      commit(GST_REBILLING_SUCCESS, commitResult)
    } catch (error) {
      commit(GST_REBILLING_FAIL, extractMessages(error))
    }
  },
  async downloadGLTranInit({ commit, state }) {
    commit(DOWNLOAD_GL_TRAN_LOADING)
    const apiUrl = state.menu.downloadGLTran
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      let commitResult = {
        menu: menu
      }
      commit(DOWNLOAD_GL_TRAN_SUCCESS, commitResult)
    } catch (error) {
      commit(DOWNLOAD_GL_TRAN_FAIL, extractMessages(error))
    }
  },
  async ifrsDataExtractionInit({ commit, state }) {
    commit(IFRS_DATA_EXTRACTION_LOADING)
    const apiUrl = state.menu.ifrsDataExtraction
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      let commitResult = {
        menu: menu
      }
      commit(IFRS_DATA_EXTRACTION_SUCCESS, commitResult)
    } catch (error) {
      commit(IFRS_DATA_EXTRACTION_FAIL, extractMessages(error))
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
